import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=147c1a69&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=147c1a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c1a69",
  null
  
)

export default component.exports